import React, { useState, useRef } from "react"

import DayPickerInput from "react-day-picker/DayPickerInput"
import { DateUtils } from "react-day-picker"
import dateFnsFormat from "date-fns/format"
import dateFnsParse from "date-fns/parse"

const DateField = ({ field, form, label, startDate, ...props }) => {
  const FORMAT = "dd/MM/yyyy"
  const elDate = useRef(null)
  const selected = field.value
  const [, setOpen] = useState(false)
  let disableBefore

  if (props.disableBefore) {
    disableBefore = form.values[props.disableBefore]
  }

  const parseDate = (str, format, locale) => {
    const parsed = dateFnsParse(str, format, Date.now())
    if (DateUtils.isDate(parsed) && parsed.getFullYear() > 1000) {
      return parsed
    }
    return undefined
  }
  const formatDate = (date, format, locale) => {
    return dateFnsFormat(date, format)
  }
  const handleChange = val => {
    form.setFieldValue(field.name, val)

    // const isValid = props.formIsValid

    //console.log(props.formIsValid)
    // dispatch(
    //   updateCategoryClaimData(
    //     category,
    //     targetCoverageCode,
    //     inputName,
    //     inputValue
    //   )
    // )
  }

  const modifiers = () => {
    let limitedDate = {}

    if (disableBefore) {
      limitedDate.before = disableBefore
      limitedDate.after = new Date()
    } else {
      limitedDate.after = new Date()
    }

    return limitedDate
  }
  // const invalid = form.touched[field.name] && !!form.errors[field.name]
  return (
    <>
      {/* <label style={{ marginBottom: "0px" }}>{label}</label> */}
      <DayPickerInput
        classNames={props.classNames}
        inputProps={{
          required: true,
          readOnly: true,
          name: props.inputProps.name,
          //className: props.className,
        }}
        ref={elDate}
        format={FORMAT}
        autoComplete="new-password"
        value={selected}
        placeholder={`DD/MM/YYYY`}
        formatDate={formatDate}
        parseDate={parseDate}
        //name={props.inputProps.name}
        dayPickerProps={{
          disabledDays: modifiers(),
          numberOfMonths: 1,
          onDayClick: () => elDate.current.getInput().focus(),
        }}
        onDayChange={handleChange}
        onDayPickerShow={() => setOpen(false)}
        onDayPickerHide={() => setOpen(false)}
      />
    </>
  )
}
export default DateField
